<template>
  <div>
    <top-header type="6" placeholder="热门问题" fontSize="0.32rem" />
    <div class="list_main">
      <div id="line" class="pad_top"></div>
      <div class="search_con">
        <van-search v-model="brokerName" placeholder="请输入问题" shape="round" @search="submit" />
      </div>
      <div class="list">
        <div class="row m_flex_box flex_vc flex_jz" v-for="(item, index) in list" :key="item.id" @click="detail(item.id,item.type)">
          <div class="left m_flex_box flex_vc">
            <span :style="{ color: index < 3 ? '#FE830B' : '#B8C9EB' }">
              {{ (index + 1) }}.
            </span>
            <div>
              <div class="h3">{{ item.title }}</div>
            </div>
          </div>
          <img src="@/assets/img/right.png" class="arrow_all" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import topHeader from '@/components/header'
export default {
  data() {
    return {
      type: this.$route.query.type,
      id: this.$route.query.id,
      list: [],
      brokerName: "",
      title: ""
    };
  },
  components: {
    topHeader,
  },
  mounted() {
    this.init()
  },
  methods: {
    changeType(num) {
      this.current = num
      this.init()
    },
    submit() {
      this.init()
    },
    detail(id,type){
      this.$router.push({
        path: "/consultingService_three",
        query: {
          id: id,
          type: type
        }
      });
    },
    init() {
      this.$request_xf.get("service/api/queryIssueTitle?type=" + this.type + "&classificationId=" + this.id + "&keyword=" + this.brokerName).then((res) => {
        this.list = res.result;
      }).catch(res => {
        this.$toast(res.msg);
      });
    }
  }
}
</script>
<style lang="less" scoped>
.fixed {
  background-color: #F8F8F8;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: 9;

  .top_normal {
    height: 100%;

    .i {
      font-size: 18px;
    }
  }
}



.search_con {
  background-color: #ffffff;
  border-radius: 20px;
  height: 1rem;
  width: 100%;
  box-sizing: border-box;
  font-size: 18px;
  padding: 0 0.2rem;
  color: #303030;

  .i {
    font-size: 18px;
    margin-right: 0.2rem;
  }
}


.arrow_all {
  width: 0.4rem;
  height: 0.4rem
}


.list {
  margin: 0 0.15rem;
  padding: 0 0.15rem;

  .row {
    width: 100%;
    padding:0.2rem 0;
    border-bottom: 1px solid #f5f5f5;

    .left {
      .h3 {
        font-size: 16px;
        color: #101010;
        // font-weight: 800;
      }

      .p {
        font-size: 14px;
        color: #A0A0A0;
      }

      &>span {
        font-size: 18px;
        font-weight: 700;
        margin-right: 24px;
        font-style: italic;
      }
    }

    .i {
      font-size: 26px;
      color: #A0A0A0;
    }
  }
}
</style>